export default "__VITE_ASSET__e0f716ad__"